export interface LifiTransactionRequest {
    data: string;
    value: string;
    to: string;
}
